import { Hidden }                   from "@material-ui/core";
import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { DropdownItemProps, Form }  from "semantic-ui-react";
import PlanAmount                   from "../../../domain/plan/PlanAmount";
import PlanDayLimit                 from "../../../domain/plan/PlanDayLimit";
import PlanDescription              from "../../../domain/plan/PlanDescription";
import PlanName                     from "../../../domain/plan/PlanName";
import PlanStatusType               from "../../../domain/plan/PlanStatusType";
import PlanTaxIncludeType           from "../../../domain/plan/PlanTaxIncludeType";
import PlanTimeType                 from "../../../domain/plan/PlanTimeType";
import { ResKaState }               from "../../../index";
import {
  setPlanAmountAction,
  setPlanDescriptionAction,
  setPlanLimitDayAction,
  setPlanNameAction,
  setPlanStatusTypeAction,
  setPlanTaxIncludeTypeAction,
  setPlanTimeTypeAction,
  usePlan
}                                   from "../../../infrastructure/redux/plan/plan";
import "./PlanForm.scss";

const PlanForm: FC = () => {
  const dispatch = useDispatch();
  const plan = usePlan();
  const errors = useSelector((state: ResKaState) => state.errors);
  const options: DropdownItemProps[] = [
    {
      key: PlanTimeType.MINUTE_15,
      text: "15分",
      value: PlanTimeType.MINUTE_15
    },
    {
      key: PlanTimeType.MINUTE_30,
      text: "30分",
      value: PlanTimeType.MINUTE_30
    },
    {
      key: PlanTimeType.MINUTE_60,
      text: "60分",
      value: PlanTimeType.MINUTE_60
    },
    {
      key: PlanTimeType.MINUTE_90,
      text: "90分",
      value: PlanTimeType.MINUTE_90
    },
    {
      key: PlanTimeType.MINUTE_120,
      text: "120分",
      value: PlanTimeType.MINUTE_120
    },
  ];

  const onChangeName = (value: PlanName) => {
    dispatch(setPlanNameAction(value));
  };

  const onChangeDescription = (value: PlanDescription) => {
    dispatch(setPlanDescriptionAction(value));
  };

  const onChangeAmount = (value: PlanAmount) => {
    dispatch(setPlanAmountAction(value));
  };

  const onChangeTaxIncludeType = (value: PlanTaxIncludeType) => {
    dispatch(setPlanTaxIncludeTypeAction(value));
  };

  const onChangeTimeType = (value: PlanTimeType) => {
    dispatch(setPlanTimeTypeAction(value));
  };

  const onChangeStatusType = (value: PlanStatusType) => {
    dispatch(setPlanStatusTypeAction(value));
  };

  const onChangeDayLimit = (value: PlanDayLimit) => {
    dispatch(setPlanLimitDayAction(value));
  };

  return (
    <>
      <Form>
        <Hidden smDown>
          <Form.Group>
            <Form.Field>
              <Form.Input
                className="plan-input"
                required
                label="プラン名"
                placeholder="プラン名を入力してください"
                value={ plan.name.toString() }
                onChange={ (event, data) => onChangeName(new PlanName(data.value)) }
                error={ errors.has("name") ? {
                  content: errors.getMessage("name"),
                  pointing: "below",
                } : undefined }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <Form.TextArea
                className="plan-input"
                required
                rows={ 10 }
                label="プラン説明"
                placeholder="プラン説明を入力してください"
                value={ plan.description.toString() }
                onChange={ (event, data) => onChangeDescription(new PlanDescription(String(data.value))) }
                error={ errors.has("description") ? {
                  content: errors.getMessage("description"),
                  pointing: "below",
                } : undefined }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <Form.Input
                className="plan-input"
                type="number"
                required
                label="金額"
                placeholder="金額を入力してください"
                value={ plan.amount.toNumber() }
                onChange={ (event, data) => onChangeAmount(new PlanAmount(Number(data.value))) }
                error={ errors.has("amount") ? {
                  content: errors.getMessage("amount"),
                  pointing: "below",
                } : undefined }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <Form.Radio
                toggle
                label="上記金額に消費税を含みます"
                checked={ plan.taxIncludeType === PlanTaxIncludeType.INCLUDE }
                onClick={ () => {
                  switch (plan.taxIncludeType) {
                    default:
                    case PlanTaxIncludeType.NOT_INCLUDE:
                      onChangeTaxIncludeType(PlanTaxIncludeType.INCLUDE);
                      break;
                    case PlanTaxIncludeType.INCLUDE:
                      onChangeTaxIncludeType(PlanTaxIncludeType.NOT_INCLUDE);
                      break;
                  }
                } }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <small>
                <p>※ 上記金額に消費税を含んだ金額を設定する場合、有効にしてください。</p>
                <p>※ この設定が無効の場合、WEB予約画面で自動的に消費税が計算されて表示されます。</p>
              </small>
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <Form.Dropdown
                className="plan-input"
                required
                label="予約時間"
                placeholder="予約時間を選択してください"
                selection
                options={ options }
                value={ plan.timeType }
                onChange={ (event, data) => {
                  switch (data.value) {
                    default:
                    case PlanTimeType.MINUTE_30:
                      onChangeTimeType(PlanTimeType.MINUTE_30);
                      break;
                    case PlanTimeType.MINUTE_120:
                      onChangeTimeType(PlanTimeType.MINUTE_120);
                      break;
                    case PlanTimeType.MINUTE_90:
                      onChangeTimeType(PlanTimeType.MINUTE_90);
                      break;
                    case PlanTimeType.MINUTE_60:
                      onChangeTimeType(PlanTimeType.MINUTE_60);
                      break;
                    case PlanTimeType.MINUTE_15:
                      onChangeTimeType(PlanTimeType.MINUTE_15);
                      break;
                  }
                } }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <Form.Input
                className="plan-input"
                type="number"
                required
                label="１日の予約上限数"
                placeholder="１日の予約上限数を入力してください"
                value={ plan.dayLimit.toString() }
                onChange={ (event, data) => onChangeDayLimit(new PlanDayLimit(Number(data.value))) }
                error={ errors.has("day_limit") ?
                  {
                    content: errors.getMessage("day_limit"),
                    pointing: "below",
                  } :
                  undefined
                }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <Form.Radio
                toggle
                label="このプランの予約を受け付けます"
                checked={ plan.statusType === PlanStatusType.PUBLISH }
                onClick={ () => {
                  switch (plan.statusType) {
                    default:
                    case PlanStatusType.PRIVATE:
                      onChangeStatusType(PlanStatusType.PUBLISH);
                      break;
                    case PlanStatusType.PUBLISH:
                      onChangeStatusType(PlanStatusType.PRIVATE);
                      break;
                  }
                } }
              />
            </Form.Field>
          </Form.Group>
        </Hidden>

        <Hidden mdUp>
          <Form.Field>
            <Form.Input
              required
              label="プラン名"
              placeholder="プラン名を入力してください"
              value={ plan.name.toString() }
              onChange={ (event, data) => onChangeName(new PlanName(data.value)) }
              error={ errors.has("name") ? {
                content: errors.getMessage("name"),
                pointing: "below",
              } : undefined }
            />
          </Form.Field>
          <Form.Field>
            <Form.TextArea
              required
              rows={ 10 }
              label="プラン説明"
              placeholder="プラン説明を入力してください"
              value={ plan.description.toString() }
              onChange={ (event, data) => onChangeDescription(new PlanDescription(String(data.value))) }
              error={ errors.has("description") ? {
                content: errors.getMessage("description"),
                pointing: "below",
              } : undefined }
            />
          </Form.Field>
          <Form.Field>
            <Form.Input
              required
              label="金額"
              placeholder="金額を入力してください"
              value={ plan.amount.toNumber() }
              onChange={ (event, data) => onChangeAmount(new PlanAmount(Number(data.value))) }
              error={ errors.has("amount") ? {
                content: errors.getMessage("amount"),
                pointing: "below",
              } : undefined }
            />
          </Form.Field>
          <Form.Field>
            <Form.Radio
              toggle
              label="上記金額に消費税含みます"
              checked={ plan.taxIncludeType === PlanTaxIncludeType.INCLUDE }
              onClick={ () => {
                switch (plan.taxIncludeType) {
                  default:
                  case PlanTaxIncludeType.NOT_INCLUDE:
                    onChangeTaxIncludeType(PlanTaxIncludeType.INCLUDE);
                    break;
                  case PlanTaxIncludeType.INCLUDE:
                    onChangeTaxIncludeType(PlanTaxIncludeType.NOT_INCLUDE);
                    break;
                }
              } }
            />
          </Form.Field>
          <Form.Field>
            <small>
              <p>※ 上記金額に消費税を含んだ金額を設定する場合、有効にしてください。</p>
              <p>※ この設定が無効の場合、WEB予約画面で自動的に消費税が計算されて表示されます。</p>
            </small>
          </Form.Field>
          <Form.Field>
            <Form.Dropdown
              className="plan-input"
              required
              label="予約時間"
              placeholder="予約時間を選択してください"
              selection
              options={ options }
              value={ plan.timeType }
              onChange={ (event, data) => {
                switch (data.value) {
                  default:
                  case PlanTimeType.MINUTE_30:
                    onChangeTimeType(PlanTimeType.MINUTE_30);
                    break;
                  case PlanTimeType.MINUTE_120:
                    onChangeTimeType(PlanTimeType.MINUTE_120);
                    break;
                  case PlanTimeType.MINUTE_90:
                    onChangeTimeType(PlanTimeType.MINUTE_90);
                    break;
                  case PlanTimeType.MINUTE_60:
                    onChangeTimeType(PlanTimeType.MINUTE_60);
                    break;
                  case PlanTimeType.MINUTE_15:
                    onChangeTimeType(PlanTimeType.MINUTE_15);
                    break;
                }
              } }
            />
          </Form.Field>
          <Form.Field>
            <Form.Input
              type="number"
              required
              label="１日の予約上限数"
              placeholder="１日の予約上限数を入力してください"
              value={ plan.dayLimit.toString() }
              onChange={ (event, data) => onChangeDayLimit(new PlanDayLimit(Number(data.value))) }
              error={ errors.has("day_limit") ?
                {
                  content: errors.getMessage("day_limit"),
                  pointing: "below",
                } :
                undefined
              }
            />
          </Form.Field>
          <Form.Field>
            <Form.Radio
              toggle
              label="このプランの予約を受け付けます"
              checked={ plan.statusType === PlanStatusType.PUBLISH }
              onClick={ () => {
                switch (plan.statusType) {
                  default:
                  case PlanStatusType.PRIVATE:
                    onChangeStatusType(PlanStatusType.PUBLISH);
                    break;
                  case PlanStatusType.PUBLISH:
                    onChangeStatusType(PlanStatusType.PRIVATE);
                    break;
                }
              } }
            />
          </Form.Field>
        </Hidden>
      </Form>
    </>
  );
};

export default PlanForm;
